import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/auth.store';
import { useState } from 'react';

interface NavGroup {
  label?: string;
  items: ReadonlyArray<{ to: string; label: string; icon: string }>;
}

const NAV: ReadonlyArray<NavGroup> = [
  {
    label: 'Знакомство',
    items: [
      { to: '/onboarding', label: 'Начало работы',  icon: '🎓' },
      { to: '/guide',      label: 'Руководство',     icon: '📖' },
    ],
  },
  {
    label: 'Конвейер',
    items: [
      { to: '/topics',    label: 'Темы',        icon: '📋' },
      { to: '/scripts',   label: 'Скрипты',     icon: '✍️' },
      { to: '/videos',    label: 'Видео',       icon: '🎬' },
      { to: '/calendar',  label: 'Календарь',   icon: '📅' },
      { to: '/analytics', label: 'Аналитика',   icon: '📊' },
    ],
  },
  {
    label: 'Инструменты',
    items: [
      { to: '/knowledge', label: 'База знаний', icon: '📚' },
      { to: '/hooks',     label: 'Хуки',        icon: '🎯' },
      { to: '/settings',  label: 'Настройки',   icon: '⚙️' },
    ],
  },
];

export function NavBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const [mobileOpen, setMobileOpen] = useState(false);

  function handleLogout() {
    logout();
    navigate('/login');
  }

  return (
    <>
      {/* Mobile burger */}
      <button
        onClick={() => setMobileOpen(!mobileOpen)}
        className="lg:hidden fixed top-4 left-4 z-40 w-10 h-10 rounded-xl bg-white/80 backdrop-blur border border-slate-200 flex items-center justify-center shadow-md"
        aria-label="Меню"
      >
        ☰
      </button>

      {/* Backdrop on mobile */}
      {mobileOpen && (
        <div
          className="lg:hidden fixed inset-0 z-40 bg-slate-900/30 backdrop-blur-sm"
          onClick={() => setMobileOpen(false)}
        />
      )}

      <aside
        className={`fixed top-0 left-0 h-screen w-64 z-50 bg-white/80 backdrop-blur-xl border-r border-slate-200/60 shadow-[1px_0_20px_rgba(0,0,0,0.03)] flex flex-col transition-transform ${
          mobileOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0`}
      >
        {/* Logo */}
        <Link to="/topics" onClick={() => setMobileOpen(false)} className="flex items-center gap-3 px-5 pt-5 pb-4 border-b border-slate-100">
          <span className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-600 flex items-center justify-center text-white text-base font-bold shadow-[0_4px_14px_rgba(79,70,229,0.35)]">
            ▶
          </span>
          <div>
            <div className="font-bold text-slate-900 leading-tight">HeyGen</div>
            <div className="text-[11px] text-slate-500">Content Factory</div>
          </div>
        </Link>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-5">
          {NAV.map((group) => (
            <div key={group.label}>
              {group.label && (
                <div className="px-3 mb-2 text-[10px] uppercase tracking-wider text-slate-400 font-semibold">
                  {group.label}
                </div>
              )}
              <div className="space-y-0.5">
                {group.items.map((item) => {
                  const isActive = location.pathname === item.to
                    || location.pathname.startsWith(item.to + '/');
                  return (
                    <Link
                      key={item.to}
                      to={item.to}
                      onClick={() => setMobileOpen(false)}
                      className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition-all ${
                        isActive
                          ? 'bg-gradient-to-br from-indigo-500 to-violet-600 text-white shadow-[0_4px_14px_rgba(79,70,229,0.35)]'
                          : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100/80'
                      }`}
                    >
                      <span className="text-base w-5 text-center">{item.icon}</span>
                      <span className="font-medium">{item.label}</span>
                    </Link>
                  );
                })}
              </div>
            </div>
          ))}
        </nav>

        {/* Footer with user */}
        <div className="border-t border-slate-100 p-3">
          {user && (
            <div className="px-3 py-2 mb-2">
              <div className="text-xs text-slate-400">Вошёл как</div>
              <div className="text-sm font-medium text-slate-700 truncate">{user.email}</div>
              <div className="text-[11px] text-slate-400">{user.role}</div>
            </div>
          )}
          <button onClick={handleLogout} className="w-full btn btn-sm btn-ghost justify-start">
            ← Выйти
          </button>
        </div>
      </aside>
    </>
  );
}
